module.exports = __webpack_public_path__ + "static/media/June2022Newsletter.e735baa5.pdf";